export function PeopleIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M108.771 62.8291C119.698 62.8291 128.571 71.7024 128.571 82.6289C128.571 87.3047 126.884 91.861 123.805 95.4609L121.371 98.3018L124.324 100.622H124.332C130.47 105.445 134 112.659 134 120.4C134 122.383 132.383 124 130.4 124C128.418 124 126.8 122.383 126.8 120.4C126.8 110.479 118.721 102.4 108.8 102.4C100.791 102.4 93.662 107.766 91.4824 115.472C90.0619 120.492 85.3295 124 80 124C74.6775 124 69.938 120.492 68.5176 115.472C66.338 107.78 59.2087 102.4 51.2002 102.4C41.2791 102.4 33.2002 110.479 33.2002 120.4C33.2001 122.383 31.5824 124 29.5996 124C27.6171 124 26.0001 122.383 26 120.4C26 112.667 29.5084 105.446 35.6465 100.622L38.5996 98.3018L36.167 95.4609C33.0944 91.882 31.4004 87.3258 31.4004 82.6289C31.4004 71.7024 40.2737 62.8291 51.2002 62.8291C62.1266 62.8292 71 71.7024 71 82.6289C71 87.3258 69.312 91.9025 66.2324 95.4814L63.7861 98.3438L66.7393 100.664C70.9647 103.997 73.9742 108.44 75.4297 113.552C75.992 115.492 77.841 116.843 79.9854 116.843C82.1299 116.843 84.0006 115.492 84.542 113.552C85.9764 108.454 88.9857 103.997 93.2324 100.664L96.1855 98.3438L93.7383 95.4814C90.666 91.8815 88.9717 87.3256 88.9717 82.6289C88.9717 71.7024 97.845 62.8291 108.771 62.8291ZM51.1924 70.001C44.2455 70.001 38.5928 75.6537 38.5928 82.6006C38.5928 89.5475 44.2455 95.2002 51.1924 95.2002C58.1393 95.2002 63.792 89.5475 63.792 82.6006C63.7919 75.6537 58.1393 70.001 51.1924 70.001ZM108.792 70.001C101.845 70.0012 96.1924 75.6539 96.1924 82.6006C96.1924 89.5474 101.845 95.2 108.792 95.2002C115.739 95.2002 121.393 89.5475 121.393 82.6006C121.393 75.6537 115.739 70.001 108.792 70.001ZM79.9922 16C90.9186 16.0001 99.7918 24.8735 99.792 35.7998C99.792 46.7263 90.9187 55.6005 79.9922 55.6006C69.0656 55.6006 60.1924 46.7263 60.1924 35.7998C60.1926 24.8734 69.0658 16 79.9922 16ZM79.9922 23.2002C73.0454 23.2002 67.3918 28.8531 67.3916 35.7998C67.3916 42.7467 73.0453 48.4004 79.9922 48.4004C86.9391 48.4003 92.5918 42.7467 92.5918 35.7998C92.5916 28.8531 86.9389 23.2002 79.9922 23.2002Z"
        fill="url(#paint0_linear_43_481)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_481"
          x1="80"
          y1="16"
          x2="80"
          y2="124"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
